import { useBilling } from '@/features/billing/hooks/useBilling';
import { useUpgradeModal } from '@/features/billing/hooks/useUpgradeModal';
import type {
  GetRedirectUrlParams,
  PackageId,
  SubscriptionType,
} from '@/features/billing/types';
import { useAnalytics } from '@/hooks/useAnalytics';
import { Button, type ButtonProps } from '@/ui';

interface SubscriptionButtonProps extends ButtonProps {
  subscriptionType: SubscriptionType;
  redirect?: GetRedirectUrlParams;
  /** Which package to check out. Omit to use the default (Plus annual). */
  packageId?: PackageId;
  /** Business packages only: seat packs to include in the checkout. */
  packs?: number;
  children: React.ReactNode;
}

export const UpgradeButton = ({
  subscriptionType,
  redirect,
  packageId,
  packs,
  children,
  onClick,
  ...buttonProps
}: SubscriptionButtonProps) => {
  const { redirectToCheckout } = useBilling();
  const { trackEvent } = useAnalytics();
  const { experienceType, config, feature } = useUpgradeModal();

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    trackEvent('upgrade-modal:click purchase', {
      launch: redirect?.launch ?? undefined,
      feature,
      experienceType,
      config,
    });

    if (onClick) {
      onClick(e);
    }
    await redirectToCheckout(subscriptionType, redirect, packageId, {
      packs,
      feature,
    });
  };

  return (
    <Button onClick={handleClick} {...buttonProps}>
      {children}
    </Button>
  );
};
